import script from "./ErrorMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&setup=true&lang=js"

import "@/shared/styles/ErrorMessage.css?vue&type=style&index=0&id=a8a3533c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8a3533c"]])

export default __exports__